export default __webpack_public_path__ + "static/media/1.ce0dc5a4.png";